import {Component, OnDestroy} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {EntiteBody} from '../../../../models/entite/EntiteBody';
import {EntiteService} from '../../../../services/entites/entite.service';
import {Subscription} from 'rxjs';
import {MatSnackBar, MatSnackBarModule, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';

@Component({
  selector: 'app-creer-entite-dialogue',
  standalone: true,
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonToggleModule, MatButtonModule, MatDialogModule, MatDividerModule, MatIconModule, MatSnackBarModule],
  templateUrl: './creer-entite-dialogue.component.html',
  styleUrl: './creer-entite-dialogue.component.scss'
})

export class CreerEntiteDialogueComponent implements OnDestroy {
  formSubmitted: boolean = false;
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  entiteForm = new FormGroup({
    libelle: new FormControl('', Validators.required),
    interne: new FormControl('', Validators.required),
    actif: new FormControl(true),
    referentNom: new FormControl(''),
    referentEmail: new FormControl('', [Validators.email]),
    referentTelephone: new FormControl('', [Validators.pattern('^[0-9]{10}$')])
  });
  private subscription: Subscription = new Subscription();

  constructor(private dialogRef: MatDialogRef<CreerEntiteDialogueComponent>, private entiteService: EntiteService,
              public snackBar: MatSnackBar) {
  }

  onSubmit() {
    this.formSubmitted = true;
    if (this.entiteForm.invalid) {
      alert('Le formulaire contient des erreurs, veuillez les corriger avant de soumettre !');
      return;
    }
    const formValue = this.entiteForm.value;
    const interne = formValue.interne === 'interne';
    const entite: EntiteBody = new EntiteBody(
      formValue.libelle ?? '',
      interne,
      true,
      formValue.referentNom || undefined,
      formValue.referentEmail || undefined,
      formValue.referentTelephone || undefined
    );
    const subscription = this.entiteService.postEntity(entite).subscribe({
      next: (response) => {
        console.log('Entity created successfully', response);
        this.snackBar.open('Entité créée avec succès !', 'Fermer', {
          verticalPosition: this.verticalPosition,
          duration: 5000,
          panelClass: ['snackbar-success']
        });
        this.onClose();
      },
      error: (error) => {
        console.error('Error creating entity', error);
        this.entiteForm.controls['libelle'].setErrors({libelleExists: true});
        this.snackBar.open('Erreur lors de la création de l’entité: ', 'Fermer', {
          verticalPosition: this.verticalPosition,
          duration: 5000,
          panelClass: ['snackbar-error']
        });
      }
    });
    this.subscription.add(subscription);
  }

  onClose() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
